import React from 'react';
import Icon from '../AppIcon';
import { cn } from '../../utils/cn';

const StarRating = ({ 
  value = 0, 
  onChange = null, 
  maxStars = 5, 
  size = 16,
  readonly = false,
  className = ''
}) => {
  const handleStarClick = (starValue) => {
    if (!readonly && onChange) {
      onChange(starValue === value ? 0 : starValue);
    }
  };

  return (
    <div className={cn('flex items-center gap-1', className)}>
      {Array.from({ length: maxStars }, (_, index) => {
        const starValue = index + 1;
        const isFilled = starValue <= value;
        
        return (
          <button
            key={starValue}
            type="button"
            onClick={() => handleStarClick(starValue)}
            disabled={readonly}
            className={cn(
              'transition-all duration-200',
              !readonly && 'hover:scale-110 cursor-pointer',
              readonly && 'cursor-default'
            )}
            aria-label={`${starValue} star${starValue > 1 ? 's' : ''}`}
          >
            <Icon
              name="star"
              size={size}
              color={isFilled ? '#F59E0B' : '#D1D5DB'}
              fill={isFilled ? '#F59E0B' : 'none'}
            />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;